// Risk Register: the route and the sidebar row of
// `wealth.intelligence.risk-register` (ADR-0027).
//
// The page is an empty state: no source fills it yet. Dowgate staff see it
// today, so the Dowgate manifest turns the feature on.
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.intelligence.risk-register',
    routes: [
        {
            frontend: 'view',
            path: 'risk-register',
            lazy: () => import('@/pages/view/risk-register/page'),
        },
    ],
    nav: [
        {
            frontend: 'view',
            key: 'risk-register',
            label: 'Risk Register',
            href: '/view/risk-register',
            icon: 'AlertOctagon',
            group: 'clients-risk',
            order: 430,
        },
    ],
});
